import { Component, type ReactNode } from 'react';
import { reportClientError } from '../lib/reportError.ts';

/**
 * Fanger render-feil slik at en krasj viser en lesbar melding (med feiltekst)
 * i stedet for en blank/hvit side. Bruker inline-stiler så den vises selv om
 * Tailwind/CSS skulle feile.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: unknown) {
    console.error('App-feil:', error, info);
    reportClientError(error, (info as { componentStack?: string } | null)?.componentStack);
  }

  render() {
    const err = this.state.error;
    if (!err) return this.props.children;
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 12,
          padding: 24,
          background: '#0f172a',
          color: '#e2e8f0',
          textAlign: 'center',
          fontFamily: 'system-ui, sans-serif',
        }}
      >
        <div style={{ fontSize: 32 }}>⚠️</div>
        <h1 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>Noe gikk galt</h1>
        <p style={{ fontSize: 13, color: '#94a3b8', maxWidth: 360, margin: 0 }}>
          Siden klarte ikke å vises. Prøv å laste på nytt.
        </p>
        <pre
          style={{
            fontSize: 11,
            color: '#fca5a5',
            maxWidth: 360,
            whiteSpace: 'pre-wrap',
            overflow: 'auto',
            margin: 0,
          }}
        >
          {String(err.message || err)}
        </pre>
        <button
          onClick={() => {
            this.setState({ error: null });
            location.reload();
          }}
          style={{
            padding: '8px 16px',
            background: '#0284c7',
            color: '#fff',
            border: 0,
            borderRadius: 8,
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          Last på nytt
        </button>
        <a href="/" style={{ fontSize: 13, color: '#38bdf8' }}>
          Til forsiden
        </a>
      </div>
    );
  }
}
